export default __webpack_public_path__ + "cf2f69b776506d7f5b80f8a11d9e1db4.svg";